import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import './scrollArea.css';
import { HTMLProps } from 'react';

export type ScrollAreaProps = {
  style?: HTMLProps<HTMLDivElement>['style'];
  className?: HTMLProps<HTMLDivElement>['className'];
  children: React.ReactNode;
};

export const ScrollArea: React.FC<ScrollAreaProps> = ({ children, ...props }) => {
  return <OverlayScrollbarsComponent {...props}> {children}</OverlayScrollbarsComponent>;
};
